import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';
registerModuleCatalog('credit-product-rules', (locale) => import(`./locales/${locale}.po`), {
  eager: true,
});
export const loadProductRulesMessages = () => ensureModuleMessages('credit-product-rules');
